import { render } from "./index.vue?vue&type=template&id=0acba035&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0acba035&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0acba035"

export default script